import React, { Component } from 'react'

export default class ToolTip extends Component {

  render(){
    const { value, display, style, className } = this.props
    const classname = `tooltip-d shadow ${className || ''}`
    return (
      <div style={style || {}} className={classname}>
        <div className='tooltip-d-wrapper'>
          <span className='tooltip-d__content'>
            {value}
          </span>
        </div>
      </div>
    )
  }

}
